/**
 * Universal status object which can be used to implement status related functionality such as AnimatedStatusSign
 */
export enum Status {
    Success,
    Warning,
    Error,
}
